import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "chats";

export const createRoomAsync = async (id) => {
  const { data } = await http.post(`${apiEndpoint}/rooms/${id}`);
  return data.result;
};

export const getRoomsAsync = async (id, page) => {
  const url = `${apiEndpoint}/rooms/${id}?p=${page}&s=10`;

  const { data } = await http.get(url);
  return data;
};

export const getUnreadMessagesAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/messages/unread`);
  return data;
};

export const saveNewMessageAsync = async (info) => {
  const { data } = await http.post(`${apiEndpoint}/messages`, info);
  return data.result;
};

export const saveMessageAsync = async (info) => {
  const { data } = await http.post(`${apiEndpoint}/rooms/messages`, info);
  return data.result;
};

export const saveAttachmentAsync = async (id, data) => {
  return await http.post(`${apiEndpoint}/rooms/messages/${id}`, data);
};

export const assignUsersAsync = async (id, data) => {
  const url = `${apiEndpoint}/rooms/members/${id}`;
  return await http.post(url, data);
};

export const removeUserAsync = async (id) => {
  const url = `${apiEndpoint}/rooms/members/${id}`;
  return await http.delete(url);
};

export const getRoomMessagesAsync = async (id, page) => {
  const url = `${apiEndpoint}/rooms/messages/${id}?p=${page}&s=20`;

  const { data } = await http.get(url);
  return data;
};

export const getRoomMembersAsync = async (id) => {
  const url = `${apiEndpoint}/rooms/members/${id}`;
  const { data } = await http.get(url);
  return data;
};

export const getAvailableUsersAsync = async (id) => {
  const url = `${apiEndpoint}/rooms/users/${id}`;
  const { data } = await http.get(url);
  return data;
};

export const getAvailableAccountsAsync = async (params) => {
  const { search_query: query, current_page: page, page_size: size } = params;

  const url = `${apiEndpoint}/accounts?q=${query}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const chatService = {
  createRoomAsync,
  getRoomsAsync,
  getUnreadMessagesAsync,
  saveNewMessageAsync,
  saveMessageAsync,
  saveAttachmentAsync,
  assignUsersAsync,
  removeUserAsync,
  getRoomMessagesAsync,
  getRoomMembersAsync,
  getAvailableUsersAsync,
  getAvailableAccountsAsync,
};

export default chatService;
